import { Component, ViewEncapsulation, Input, HostBinding, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { SURVEY_SCREEN_NAME_OPTIONS } from '../../models/list';

import { SurveyAnswerDialogComponent } from './survey-answer-dialog.component';
import { UserSurveyAnswerDialogData } from './user-survey-answer-dialog-data';

@Component({
	selector: 'copo-survey',
	templateUrl: './survey.component.html',
	styleUrl: './survey.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, TranslateModule, MatButtonModule, MatIconModule]
})
export class SurveyComponent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;
	@Input() screenCode!: keyof typeof SURVEY_SCREEN_NAME_OPTIONS;
	user: User;
	saveSub?: Subscription;
	isAnsweredSurveyDisplay: boolean | undefined;
	surveyScreenCodeDisplay?: keyof typeof SURVEY_SCREEN_NAME_OPTIONS;
	showDiv = true;
	private dialogSub?: Subscription;
	private readonly screenUrl: string = location.pathname;

	constructor(
		private readonly userService: UserService,

		private readonly dialog: MatDialog,
	) {
		this.user = this.userService.user;
		const surveySettings = this.user.getSettings('survey');
		if (surveySettings) {
			this.surveyScreenCodeDisplay = surveySettings.value.page;
			this.isAnsweredSurveyDisplay = surveySettings.value.isAnswered;
		}
	}

	ngOnDestroy() {
		if (this.dialogSub) {
			this.dialogSub.unsubscribe();
		}
		if (this.saveSub) {
			this.saveSub.unsubscribe();
		}
	}

	getSurveyScreenCodeTr(screenCode: keyof typeof SURVEY_SCREEN_NAME_OPTIONS) {
		return SURVEY_SCREEN_NAME_OPTIONS[screenCode];
	}

	openSurveyAnswerDialog() {
		const dialogRef = this.dialog.open<SurveyAnswerDialogComponent, UserSurveyAnswerDialogData, string | undefined>(
			SurveyAnswerDialogComponent,
			{
				panelClass: 'survey-dialog-block',
				data: {
					screenCode: this.screenCode,
					screenUrl: this.screenUrl
				},
				disableClose: true,
			}
		);

		this.dialogSub = dialogRef.afterClosed().subscribe(result => {
			this.showDiv = result !== undefined;
		});
	}

	async noAnswer() {
		const surveyAnswer: UserSurveyAnswerDialogData = {
			screenCode: this.screenCode,
			screenUrl: this.screenUrl
		};
		this.saveSub = this.userService.saveUserSurvey(surveyAnswer).subscribe({
			next: () => {
				this.showDiv = false;
			},
			error: (error: unknown) => {
				console.error(error);
			}
		});
		await this.userService.updateSurvey(this.screenCode, false);
	}
}
